
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TipTapWrapper from "@/components/Reusable/CustomInputs/3rdPartyWrappers/TipTapWrapper.vue";
import Icon from "@/components/UI/Icon.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import {
  textAndRichTextVariableItem,
  textAndRichTextVariableOptions
} from "@/types/controls";
import { Editor } from "@tiptap/vue-2";
import VariablesDropdown from "@/components/Reusable/CustomInputs/VariablesDropdown.vue";

@Component({
  components: {
    Icon,
    Dropdown,
    TipTapWrapper,
    VariablesDropdown
  }
})
export default class RichTextInputDialog extends Vue {
  @Prop({ default: "" })
  value: unknown;

  @Prop()
  open!: boolean;

  @Prop()
  variableOptions!: textAndRichTextVariableOptions;

  @Prop({ default: () => [] })
  variableItems!: textAndRichTextVariableItem[];

  edit(newVal: string | null) {
    this.$emit("input", newVal || null);
  }

  closeDialog() {
    this.$emit("close");
  }

  insertVariable(editor: Editor, text: string) {
    editor.commands.insertContent(`{${text}}`);
  }
}
